module.exports = {
	maxWidth: '1104px',
	'maxWidth.lg': '1232px',
	'maxWidth.md': '920px',
	'maxWidth.sm': '736px',
}
